<mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column h-100 custom-card">
      <mat-card-header class="d-flex justify-content-between align-items-start">
        <div class="me-auto">
          <mat-card-title>Andamento Fatturato</mat-card-title>
          <mat-card-subtitle>
            {{ selectedYear }} - 
            {{ viewType === 'monthly' ? 'Mensile' : 'Giornaliero' }}
          </mat-card-subtitle>
        </div>

        <div class="d-flex align-items-center gap-2 hidden-mobile">
          
        <!-- Month selector for daily view -->
        <div class="custom-select-wrapper me-3">
          <mat-form-field *ngIf="viewType === 'daily'"appearance="fill" subscriptSizing="dynamic" class="month-selector">
            <!-- <mat-label>Mese</mat-label> -->
            <mat-select [(ngModel)]="selectedMonth" (selectionChange)="loadInvoiceData()">
              <mat-option *ngFor="let month of months" [value]="month.value">
                {{ month.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <!-- View selector - clean modern design -->
          <mat-button-toggle-group 
            [(ngModel)]="viewType" 
            (change)="onViewTypeChange()"
            aria-label="Tipo di visualizzazione"
            class="modern-toggle">
            <mat-button-toggle value="monthly">
              <mat-icon>calendar_month</mat-icon>
              Mensile
            </mat-button-toggle>
            <mat-button-toggle value="daily">
              <mat-icon>today</mat-icon>
              Giornaliero
            </mat-button-toggle>
          </mat-button-toggle-group>

        </div>

      </mat-card-header>

      <!-- mobile version, oputise header -->
      <div class="m-3 d-flex flex-column gap-2 visible-mobile">
        <!-- Toggle selector - full width -->
        <mat-button-toggle-group 
          [(ngModel)]="viewType" 
          (change)="onViewTypeChange()"
          aria-label="Tipo di visualizzazione"
          class="modern-toggle d-flex w-100">
          <mat-button-toggle value="monthly" class="flex-grow-1 text-center">
            <mat-icon>calendar_month</mat-icon>
            <span class="d-none d-sm-inline">Mensile</span>
            <span class="ms-1 d-inline d-sm-none">Mensile</span>
          </mat-button-toggle>
          <mat-button-toggle value="daily" class="flex-grow-1 text-center">
            <mat-icon>today</mat-icon>
            <span class="d-none d-sm-inline">Giornaliero</span>
            <span class="ms-1 d-inline d-sm-none">Giornaliero</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
        
        <!-- Month selector for daily view -->
        <div *ngIf="viewType === 'daily'" class="mt-2 custom-select-wrapper">
          <mat-form-field *ngIf="viewType === 'daily'" appearance="fill" subscriptSizing="dynamic" class="month-selector">
            <!-- <mat-label>Mese</mat-label> -->
            <mat-select [(ngModel)]="selectedMonth" (selectionChange)="loadInvoiceData()">
              <mat-option *ngFor="let month of months" [value]="month.value">
                {{ month.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <mat-card-content class="flex-grow-1">
        <div *ngIf="isLoading" class="spinner-container">
          <mat-spinner diameter="50"></mat-spinner>
        </div>

        <div *ngIf="errorMessage" class="error-message">
          <!-- <mat-icon>money_off</mat-icon> -->
          <p>{{ errorMessage }}</p>
        </div>

        <div *ngIf="!isLoading && !errorMessage" class="chart-container">
          <canvas
            baseChart
            [data]="lineChartData"
            [options]="lineChartOptions"
            [type]="lineChartType"
            >
          </canvas>
        </div>
      </mat-card-content>

      <mat-card-actions class="mb-2 d-flex justify-content-between align-items-center">
        <div class="ms-3">
          <!-- <mat-icon class="align-middle me-1" style="font-size: 18px;">info</mat-icon> -->
          Valori in Euro (€)
        </div>
        <button mat-raised-button color="primary" (click)="refreshData()">
          Ricarica dati
          <mat-icon>refresh</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
